module.exports = __webpack_public_path__ + "img/not-found.fc3839a3.svg";